import script from "./TrainerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerCard.vue?vue&type=script&setup=true&lang=js"

import "./TrainerCard.vue?vue&type=style&index=0&id=4d39eafc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d39eafc"]])

export default __exports__